export default "__VITE_ASSET__CH$wDC_q__"